// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__3Y4Yd","addWidgetButton":"Header_addWidgetButton__1eEhX","dashboardTabs":"Header_dashboardTabs__1ezuB","active":"Header_active__1GqqF"};